import React from "react";
import Contents from "../components/pages/matching/Contents";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";

const Matching = () => {
  return (
    <>
      <Header />
      <Contents />
      <Footer />
    </>
  );
};

export default Matching;
